import React from "react";
import ReactDOM from "react-dom/client";
import './index.css'
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import store from "@store/index";
const { REACT_APP_CLIENT_ID: baseURL } = process.env;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={baseURL}>
      <App />
    </GoogleOAuthProvider>
  </Provider>
);
reportWebVitals();
